<template>
  <v-card rounded="xl">
    <v-card-title class="primary white--text py-3 px-4">
      <v-icon color="white" class="mr-2">mdi-wallet-membership</v-icon>
      {{ titulo }} Membresía
    </v-card-title>

    <v-card-text class="pa-4">
      <v-form ref="form" v-model="formValido" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Nombre de la membresía"
              :rules="reglas"
              outlined
              v-model="membresia.nombre"
              prepend-inner-icon="mdi-tag"
              placeholder="Ej: Mensual, Trimestral..."
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Días de duración"
              :rules="reglasNumero"
              type="number"
              min="1"
              max="3650"
              outlined
              v-model.number="membresia.duracion"
              prepend-inner-icon="mdi-calendar-range"
              hint="Ejemplo: 30 = 1 mes, 365 = 1 año"
              persistent-hint
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Precio"
              :rules="reglasNumero"
              type="number"
              min="0"
              step="0.01"
              outlined
              v-model.number="membresia.precio"
              :prefix="moneda"
              prepend-inner-icon="mdi-currency-usd"
              hint="Sin puntos de miles, use punto decimal si aplica"
              persistent-hint
            />
          </v-col>
        </v-row>

        <!-- Vista previa -->
        <v-alert v-if="membresia.nombre && membresia.precio" color="info" text dense rounded="lg" class="mt-2">
          <strong>{{ membresia.nombre }}</strong> —
          {{ membresia.duracion }} días — Precio: <strong>{{ moneda }}{{ formatPrecio }}</strong>
        </v-alert>
      </v-form>
    </v-card-text>

    <v-card-actions class="pa-4">
      <v-btn text @click="cerrarDialogo">
        <v-icon left>mdi-close</v-icon> Cancelar
      </v-btn>
      <v-spacer />
      <v-btn color="primary" rounded :disabled="!formValido" @click="registrar" elevation="3">
        <v-icon left>mdi-content-save</v-icon>
        {{ titulo === 'Registrar' ? 'Guardar' : 'Actualizar' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'FormMembresia',
  props: ['membresia', 'titulo'],

  data: function() {
    return {
      formValido: false,
      moneda: localStorage.getItem('monedaGimnasio') || '$',
      reglas: [function(v) { return !!v || 'Este campo es requerido' }],
      reglasNumero: [
        function(v) { return (v !== '' && v !== null && v !== undefined) || 'Este campo es requerido' },
        function(v) { return (parseFloat(v) > 0) || 'Debe ser mayor a 0' },
      ],
    }
  },

  computed: {
    formatPrecio: function() {
      var p = parseFloat(this.membresia.precio)
      if (isNaN(p)) return '0.00'
      return p.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
  },

  mounted: function() {
    this.formValido = false
  },

  methods: {
    cerrarDialogo: function() {
      this.$emit('cerrado', false)
    },
    registrar: function() {
      if (!this.$refs.form.validate()) return
      // Asegurar que precio y duracion sean números, no strings
      var payload = {
        id:       this.membresia.id,
        nombre:   this.membresia.nombre,
        duracion: parseInt(this.membresia.duracion, 10),
        precio:   parseFloat(this.membresia.precio),
      }
      this.$emit('registrar', payload)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Membresias/FormMembresia.vue